import { SVGProps } from 'react';

const IcAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.8716 2.00391C30.989 2.00399 36.7583 7.7742 36.7583 14.8916C36.7582 18.6998 35.1052 22.1203 32.479 24.4795C38.7886 25.4005 43.6342 30.8343 43.6343 37.3994V41.6436C43.6343 44.0472 41.6853 45.9959 39.2817 45.9961H8.71826C6.31465 45.9959 4.36572 44.0472 4.36572 41.6436V37.3994C4.36578 30.9104 9.09979 25.527 15.3022 24.5137C12.6538 22.1534 10.9839 18.7183 10.9839 14.8916C10.9839 7.77414 16.7541 2.00391 23.8716 2.00391ZM17.4233 28.0996C12.6159 28.0997 7.26621 32.592 7.26611 37.3994V42.6621H40.5425V37.3994C40.5424 32.592 35.3841 28.0997 30.5767 28.0996H17.4233ZM23.8716 5.61426C17.7551 5.61426 14.6616 10.1779 14.6616 14.8916C14.6617 19.6052 17.9152 24.3271 23.8716 24.3271C29.8278 24.3271 33.223 19.6052 33.2231 14.8916C33.2231 10.178 29.3752 5.61434 23.8716 5.61426Z'
      fill='#64748B'
    />
  </svg>
);
export default IcAccount;
